import React from 'react'
import { styled } from '@mui/material/styles'
import { Card, Button } from '@mui/material'
import { boxShadow, primary } from '@/constant'

export const PlainCard = styled(Card)(() => ({
  flex: 1,
  marginBottom: '24px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow,
  backgroundImage: 'none',
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const FormCard = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  background: 'rgba(247,247,247,0.5)',
  padding: 30,
}))

export const DialogButton = styled(Button)(() => ({
  backgroundColor: '#F7F7F7FF',
  color: '#717579FF',
}))

const Circle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'light',
})<{ light: 'on' | 'off' }>(({ light }) => ({
  display: 'inline-block',
  width: '5px',
  height: '5px',
  borderRadius: '50%',
  backgroundColor: light === 'on' ? primary : '#fff',
  border: `1px solid ${primary}`,
}))

const Connector = styled('div')(() => ({
  display: 'inline-block',
  width: '23px',
  height: '1px',
  border: `1px solid ${primary}`,
  position: 'absolute',
  top: '48%',
  zIndex: -1,
}))
export const IndicatorIcon = () => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '4px',
        height: '100%',
        alignItems: 'center',
      }}
    >
      <Connector />
      <Circle light={'on'} />
      <Circle light={'on'} />
      <Circle light={'off'} />
    </div>
  )
}
